import { ReactComponent as FacebookIcon } from '../design-system/Icons/Facebook.svg';
import { ReactComponent as InstagramIcon } from '../design-system/Icons/Instagram.svg';
import { ReactComponent as GlobalIcon } from '../design-system/Icons/Global.svg';
import { ReactComponent as LinkedinIcon } from '../design-system/Icons/Linkedin.svg';
import React from 'react';

export enum SocialMediaTypes {
  LINKEDIN = 'LinkedIn',
  INSTAGRAM = 'Instagram',
  FACEBOOK = 'Facebook',
  WEBSITE = 'Website',
}

export type SocialNetwork = {
  name: string;
  icon: React.ElementType;
};

export const SOCIAL_NETWORKS: SocialNetwork[] = [
  { name: SocialMediaTypes.INSTAGRAM, icon: InstagramIcon },
  { name: SocialMediaTypes.LINKEDIN, icon: LinkedinIcon },
  { name: SocialMediaTypes.FACEBOOK, icon: FacebookIcon },
  { name: SocialMediaTypes.WEBSITE, icon: GlobalIcon },
];
